<template>
  <div class="h-topo-treebox">
    <div class="h-gnb-pm-tree">
      <ejs-treeview id='pmGnbTopoTree' ref='pmGnbTopoTree' :nodeSelected="nodeSelectedOfPmGnbTopoTree" :enablePersistence='true' :fields='pmGnbTopoTreeFields'></ejs-treeview>
    </div>
  </div>
</template>
<script>

export default {
  name: 'pmGnbTopoTree',
  data(){
    return {
      pmGnbTopoTreeFields: {
        dataSource: [],
        id: 'id',
        parentID: 'parentId',
        text: 'name',
        hasChildren: 'hasChildren',
        expanded: 'expanded'
      },
    }
  },
  methods: {

    // 网元树点击事件
    nodeSelectedOfPmGnbTopoTree(args) {
      const nodeInfo = this.$refs.pmGnbTopoTree.getTreeData(args.nodeData.id)[0];
      this.$emit('pmGnbTopoTreeClickEventPush', nodeInfo);
    },

    async getPmGnbTopoTree() {
      this.$axios.get('/lte/ems/pm/gnb/getPmGnbTopoTree.html').then((response) => {
        this.pmGnbTopoTreeFields = {
          dataSource: response.data.resultVal,
          id: 'id',
          parentID: 'parentId',
          text: 'name',
          hasChildren: 'hasChildren',
          expanded: 'expanded'
        };
      });
    },
  },
  mounted(){
  }
};
</script>
